export default __webpack_public_path__ + "static/media/Yudovin.a73ee18c.mp4";